import { Component, OnInit } from '@angular/core';
import { LocationDto } from 'src/app/models/LocationDto';
import { LocationsService } from 'src/app/services/locations.service';

@Component({
  selector: 'app-view-location',
  templateUrl: './view-location.component.html',
  styleUrls: ['./view-location.component.css']
})
export class ViewLocationComponent implements OnInit {


  constructor(private locationService:LocationsService ) { }
  
  Locations:LocationDto[]|undefined;
  ngOnInit(): void {
    this.loadRecords();

  }


 async  loadRecords()
  {
    
    let  resLocations = await this.locationService.getLocations().toPromise(); 
    this.Locations = <LocationDto[]> resLocations.responseData;

  }
}
